import { isInTreatment } from './finch.coffee';

const TREATMENT = 'Treatment';
const SHELL_COOKIE = 'shell_page_pull';

export function enableShellLayout() {
  let isBucketed;
  const isEnabled = isInTreatment('shell_exp_pull', TREATMENT);

  if (isEnabled) {
    isBucketed = isInTreatment('shell_finch_pull', TREATMENT);
    if (isBucketed) {
      window.Cookie.set(SHELL_COOKIE, 'true');
    }
  }

  if (!isBucketed) {
    window.Cookie.unset(SHELL_COOKIE);
  }
}
